import { render, staticRenderFns } from "./PortConfig.vue?vue&type=template&id=21c8ad4d&"
import script from "./PortConfig.vue?vue&type=script&lang=js&"
export * from "./PortConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports